<template>
  <div class="card">
    <div
      v-if="image && image.imageUri"
      class="card-image"
      :class="{square: image.size === 'square'}"
    >
      <img :src="image.imageUri" :alt="image.accessibilityText" />
    </div>
    <div class="card-content">
      <div class="card-title" v-if="title">{{ title }}</div>
      <div class="card-subtitle" v-if="subtitle">{{ subtitle }}</div>
      <div class="card-text" v-if="text && text.length > 0">
        <pre>{{ text }}</pre>
      </div>

      <div class="card-buttons" v-if="buttons">
        <a
          v-for="button in buttons"
          class="card-button"
          target="_blank"
          rel="noopener noreferrer"
          :href="button.openUriAction.uri"
        >
          <i
            v-if="button.icon && button.icon.split(' ')[0] == 'fab'"
            aria-hidden="true"
            :class="[{ 'card-button-icon': true }, button.icon]"
          ></i>
          <i
            v-else
            aria-hidden="true"
            class="material-icons card-button-icon"
          >{{ button.icon || "arrow_forward" }}</i>
          <span class="card-button-title">{{ button.title }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.card
  background-color: white
  box-shadow: 0 2px 6px 2px rgba(60,64,67,0.15)
  border-radius: 12px
  display: inline-block
  max-width: 300px
  margin: 8px
  cursor: pointer

.card-image
  width: 300px
  padding-bottom: 75%
  height: auto
  position: relative
  object-fit: cover
  border-top-right-radius: 10px
  border-top-left-radius: 10px
  overflow: hidden

.card-image.square
  height: 300px
  padding-bottom: 0

.card-image img
  width: 100%
  height: 100%
  position: absolute
  object-fit: cover

.card-content
  padding: 16px

.card-title
  font-weight: 500
  font-size: 20px
  color: #202124
  line-height: 24px
  overflow: hidden
  text-overflow: ellipsis

.card-subtitle
  font-size: 16px
  line-height: 24px
  color: #757575

.card-text
  line-height: 24px
  font-size: 14px
  color: #5F6368
  white-space: normal

.card-text pre
  white-space: pre-wrap
  word-wrap: break-word
  font-family: inherit
  margin-bottom: 0

.card-buttons
  padding-top: 8px

.card-button
  margin-top: 8px
  text-decoration: none
  line-height: 24px
  color: #4285F4
  border: 1px solid lighten(#4285F4, 25%)
  border-radius: 40px
  display: flex
  font-weight: 500
  padding: 8px 16px
  text-align: center
  position: relative

.card-button-icon
  left: 0
</style>

<script>
export default {
  name: "Card",
  props: ["title", "subtitle", "text", "image", "buttons"]
};
</script>
